<template>
<div>
  <img
    v-if="academyData.ruta_logo"
    :alt="academyData.nombre"
    :src="academyData.ruta_logo"
  >
  <span v-else>
    {{ academyData.nombre }}
  </span>
</div>
</template>

<script>
export default {
  name: 'AtomLogoPrimary',

  computed: {
    academyData () {
      return this.$store.getters.getAcademyData
    }
  }
}
</script>
